import type { ContactUserListItem } from '../../../definitions'

const compareListItemsByName = (contact1: ContactUserListItem, contact2: ContactUserListItem): number =>
  (contact1.nickname || contact1.fullName || contact1.username || '')
    .localeCompare(contact2.nickname || contact2.fullName || contact2.username || '')

export default compareListItemsByName
